/** 高级版-模板管理-组件类型 */
let flag = {
  /** 多行文本 @typeVal -1 */
  MULTITEXT: -1,
  /** 文本 @typeVal 0 */
  TEXT: 0,
  /** 数字 @typeVal 1 */
  NUMBER: 1,
  /** 日期 @typeVal 2 */
  DATE: 2,
  /** 手机号码 @typeVal 3 */
  PHONE: 3,
  /** 身份证号码 @typeVal 4 */
  IDCARD: 4,
  /** 营业执照号 @typeVal 5 */
  LICENCENO: 5,
  /** 统一社会编码格式 @typeVal 6 */
  SOCIALCODE: 6, //
  /** 电子邮箱 @typeVal 7 */
  EMAIL: 7,
  /** 单选 @typeVal 8 */
  RADIO: 8,
  /** 多选 @typeVal 9 */
  MULTIPLE: 9,

  // 签章类型-SIGNNATURE后面都是盖章
  /** 盖章 @typeVal 220 */
  SIGNNATURE: 220,
  /** 签字 @typeVal 221 */
  SIGN: 221,
  /** 签字或盖章 @typeVal 222 */
  SIGNNATUREANDSIGN: 222,
  SYSTEMDATE: 10, //系统日期
};
/**
 * 变量类型 与上面 flag 相对应
 * 1197需求 单行文本与多行文本合并为文本，移除单行文本，选择文本时，当前变量类型为多行文本
 */
let flagOptions = [
  // { value: -1, label: '多行文本' },
  // { value: 0, label: '文本' },
  { value: flag.MULTITEXT, label: '文本' },
  { value: flag.NUMBER, label: '数字' },
  { value: flag.DATE, label: '日期' },
  { value: flag.PHONE, label: '手机号码' },
  { value: flag.IDCARD, label: '身份证号码' },
  { value: flag.LICENCENO, label: '营业执照号' },
  { value: flag.SOCIALCODE, label: '统一社会编码格式' },
  { value: flag.EMAIL, label: '电子邮箱' },
  { value: flag.MULTIPLE, label: '多选' },
  { value: flag.RADIO, label: '单选' },
  { value: flag.SYSTEMDATE, label: '系统日期' }
];
//系统日期格式
let systemDateOptions = [
  { value: 'yyyy年MM月dd日', label: 'yyyy年MM月dd日' },
  { value: 'yyyy年M月d日', label: 'yyyy年M月d日' },
  { value: 'yyyy-MM-dd', label: 'yyyy-MM-dd' },
  { value: 'yyyy-M-d', label: 'yyyy-M-d' },
  { value: '二〇二〇年二月二日', label: '二〇二〇年二月二日' },
];
// 字号转px
const fontSizeToPx = {
  '初号': 56,
  '小初': 48,
  '一号': 34,
  '小一': 32,
  '二号': 29,
  '小二': 24,
  '三号': 21,
  '小三': 20,
  '四号': 18,
  '小四': 16,
  '五号': 14,
  '小五': 12,
};


/**
 *  返回字号列表，用于渲染下拉
 * */
let getFontMap = function () {
  let arr = []
  for (let x in fontSizeToPx) {
    arr.push({
      value: fontSizeToPx[x],
      label: x,
    })
  }
  return arr
}

/**
 * 根据组件类型返回对应组件配置信息
 * @currentflag 组件类型
 * */
let getFlagOption = function (currentflag) {
  switch (currentflag) {
    case flag.MULTITEXT:
      return {
        title: '多行文本框',
      };
    case flag.TEXT:
      return {
        title: '单行文本框',
      };
    case flag.NUMBER:
      return {
        title: '数字框',
      };
    case flag.DATE:
      return {
        title: '日期',
      };
    case flag.PHONE:
      return {
        title: '手机号码',
      };
    case flag.IDCARD:
      return {
        title: '身份证号码',
      };
    case flag.LICENCENO:
      return {
        title: '营业执照号',
      };
    case flag.SOCIALCODE:
      return {
        title: '统一社会信用代码',
      };
    case flag.EMAIL:
      return {
        title: '电子邮箱',
      };
    case flag.MULTIPLE:
      return {
        title: '多选'
      };
    case flag.RADIO:
      return {
        title: '单选'
      };
    // ..........签章类型...........
    case flag.SIGNNATURE:
      return {
        title: '盖章',
        imageUrl: '/images/advancedVersion/qz-gaizhang.png'
      };
    case flag.SIGN:
      return {
        title: '签字',
        imageUrl: '/images/advancedVersion/qz-qianzi.png'
      };
    case flag.SIGNNATUREANDSIGN:
      return {
        title: '签字或盖章',
        imageUrl: '/images/advancedVersion/qz-gaizhangqianzi.png'
      };
    case flag.SYSTEMDATE:
      return {
        title: '系统日期',
      };
  }
};

/**
 * 根据字体大小和个数计算默认高宽(只有一行的情况)
 *  @itemInfo {
 *    varType, // 组件类型,eg:多行文本...
 *    fontSize, // px
 *   fontMaxNum // 可输入字数
 *  }
 *
 *  width = fontMaxNum*fontSize + fontMaxNum*letterSpace + 2*padding
 *  lineHeight = fontSize + 行间距
 * */
let getWHbyFont = function ({ varType, fontSize, fontMaxNum }) {
  let rowSpacing = 4 // 行间距
  let lineHeight = fontSize + rowSpacing
  let padding = 0; // 文本框padding
  let fsize = fontSize;
  let letterSpace = 2.44; // 设置字体间隙---？这里还不够准确
  let wc = 2 // 允许误差
  // console.log('根据字体大小和个数计算高宽', fontMaxNum, jx * 2 + padding * 2 + fontMaxNum * fsize + 'px');
  return {
    'font-size': fsize + 'px',
    'height': rowSpacing + padding * 2 + fsize + wc + 'px',
    'width': letterSpace * fontMaxNum + padding * 2 + fontMaxNum * fsize + wc + 'px',
  };
};

/**
 *  根据输入框宽高计算可输入文本个数
 *  @{varType, fontSize} fontSize:px
 *  @width 输入框宽度
 *  height = fontSize*row+row*rowSpacing
 * */
let getFontNumByWH = function ({ varType, fontSize }, width = 0, height = 0) {
  let rowSpacing = 4 // 行间距
  let lineHeight = fontSize + rowSpacing
  let padding = 0; // 文本框padding
  let letterSpace = 2.44; // 设置字体间隙---？这里还不够准确
  let wc = 2 // 允许误差
  let rowFontNum = width > padding * 2 ? Math.floor((width - padding * 2 - wc) / (fontSize + letterSpace)) : 0; // 每行字数-其中宽度再减去2px每行左右间隙？这里是个估计值，
  console.log(rowFontNum, 6666);
  let rowNum = height > rowSpacing ? Math.floor((height) / (fontSize + letterSpace)) : 1; // 一共几行
  rowNum = rowNum <= 0 ? 1 : rowNum // 最少一行
  return rowFontNum * rowNum; // 文本个数-是个估计值
};

/**
 *  最大最小字体，当前字体输入框最小宽度，当前字体输入框最小高度
 *  @{varType, fontSize}
 * */
let minMaxFontInfo = function ({ varType, fontSize = 0 }) {
  let rowSpacing = 4 // 行间距
  let lineHeight = fontSize + rowSpacing
  let padding = 0; // 文本框padding
  let letterSpace = 2.44; // 设置字体间隙---？这里还不够准确
  let wc = 2 // 允许误差
  // 找到最大最小字体
  let maxFontSize = 0;
  let minFontSize = 0;
  for (let x in fontSizeToPx) {
    maxFontSize < fontSizeToPx[x] && (maxFontSize = fontSizeToPx[x]);
    minFontSize > fontSizeToPx[x] && (minFontSize = fontSizeToPx[x]);
  }
  return {
    maxFontSize, // 最大号字体
    minFontSize, // 最小号字体
    minWidth: fontSize + padding * 2 + wc, // 输入框最小宽度
    minHeight: fontSize + rowSpacing + wc, // 输入框最小高度
  };
};

export default {
  flag,
  flagOptions,
  systemDateOptions,
  fontSizeToPx,
  getFontMap,
  getFlagOption,
  getWHbyFont,
  getFontNumByWH,
  minMaxFontInfo,
};



// WEBPACK FOOTER //
// ./components/advancedVersion/flagType.js